module.exports = {
  "server":[
    {
      'id': '0',
      'name': '巡检机器人导航技术浅析',
      'from':'盈能电气',
      'img':'./static/images/tu-9.png',
      'data':'2023-04-03',
      'intro':'在巡检机器人涉及的所有技术类别中，导航技术是所有技术的基础。最好的巡检能力，离开准确的导航，就不再有丝毫意义。目前，巡检机器人适合商用的导航技术主要有以下三种：\n' +
        '<br>\n' +
        '<br>\n' +
        '1、 磁导航\n' +
        '<br>\n' +
        '在地面上铺设磁条（金属线），并在金属线上加载导引频率，通过对导引频率的识别来实现导航。\n' +
        '<br>\n' +
        '2、 激光雷达导航\n' +
        '<br>\n' +
        '向目标发射探测信号(激光束)，然后将接收到的从目标反射回来的信号(目标回波)与发射信号进行比较，作适当处理后，就可获得目标的有关信息，如目标距离、方位。\n' +
        '<br>\n' +
        '3、 视觉导航'
    },
    {
      'id': '1',
      'from':'盈能电气',
      'name': '户内和户外巡检机器人选型',
      'data':'2023-04-07',
      'img':'./static/images/tu-8.png',
      'intro':'变电站户内巡检、户外巡检，由于面向巡检对象不同，选用的机器人也有差异。\n' +
        '<br>\n' +
        '变电站户内巡检一般是针对开关室，巡检内容一般包括三类：<br>\n' +
        '1、状态巡检：表计、指示灯、标示牌<br>\n' +
        '2、设备巡检：局放、测温、声音<br>\n' +
        '3、环境巡检：SF6气体监测、温湿度、消防<br>\n' +
        '所以户内巡检机器人一般除了摄像头进行图像识别，还需要携带传感器。'
    },
  ],
  "detail":[
    {
      'id':'0',
      'name':'巡检机器人导航技术浅析',
      'article':'<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">在巡检机器人涉及的所有技术类别中，导航技术是所有技术的基础。最好的巡检能力，离开准确的导航，就不再有丝毫意义。</span><span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;">目前，巡检机器人适合商用的导航技术主要有以下三种：</span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;"><br/></span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">1、&nbsp;磁导航</span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">在地面上铺设磁条（金属线），并在金属线上加载导引频率，通过对导引频率的识别来实现导航。</span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">2、&nbsp;激光雷达导航</span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">向目标发射探测信号(激光束)，然后将接收到的从目标反射回来的信号(目标回波)与发射信号进行比较，作适当处理后，就可获得目标的有关信息，如目标距离、方位。</span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">3、&nbsp;视觉导航</span>\n' +
        '</p>\n' +
        '<p style="margin-left:52px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">通过摄像，将地形、标志等外貌特征作为导航数据，与当前地形、标志与导航数据进行比较，从而确定当前位置的导航方式。</span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">除此之外，我们也能查到INS（惯性导航）、GPS（卫星定位）、AGPS（基站辅助定位）、UWB（超宽带）导航技术：</span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px">\n' +
        '    <span style="color: rgb(63, 63, 63);"><span style="color: rgb(63, 63, 63); font-family: Wingdings; font-size: 14px;">l&nbsp;</span><span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;">INS</span></span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">据说可以做到1%的精度，不过不论是否可以做到更高，由于这个误差会不断累积，而且无法自我修正，所以，使用INS，机器人失控是早晚的事情。</span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px">\n' +
        '    <span style="color: rgb(63, 63, 63);"><span style="color: rgb(63, 63, 63); font-family: Wingdings; font-size: 14px;">l&nbsp;</span><span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;">GPS</span></span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">民用GPS最高精度可以做到10米，这是结合其他地理信息修正后的结果。我们使用手机地图时，经常会出现定位位置飘到几十米之外，那是大概率的事件。而10米的定位精度，变电站的路一般也不会有10米宽……</span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px">\n' +
        '    <span style="color: rgb(63, 63, 63);"><span style="color: rgb(63, 63, 63); font-family: Wingdings; font-size: 14px;">l&nbsp;</span><span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;">AGPS</span></span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">误差在GPS的几倍，除了不用卫星，其他就没有什么特别优点了，在地下室的场合，或许能够挖掘出一点作用。</span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px">\n' +
        '    <span style="color: rgb(63, 63, 63);"><span style="color: rgb(63, 63, 63); font-family: Wingdings; font-size: 14px;">l&nbsp;</span><span style="color: rgb(63, 63, 63); font-family: 微软雅黑; font-size: 14px;">UWB</span></span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">精度所说可以做到10cm，不过即使精度属实，由于UWB也是一个专业系统，类似机器人系统一样，20万以上的起步造价，估计没有机器人制造商可以承受。</span>\n' +
        '</p>\n' +
        '<p style="margin-left:56px;text-indent:0">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);"><br/></span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">基于以上原因，上述四种导航技术实际上很少用于巡检机器人导航。</span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">目前，国内巡检机器人制造商主要采用激光雷达导航，少量采用磁导航，而且室内应用的比例要远大于室外，这是因为磁条容易损坏、维护工作量大，特别是室外更易损坏。</span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">激光雷达主要存在的问题容易迷航。这是由于激光雷达采用地形轮廓来作为导航参照物，类似拿着一块拼图要找出在整个拼图图案中的位置，如果地形轮廓相似，甚至差异点小于噪声，那即使后期算法如何改进，要准确拼图也是几乎不可能。</span>\n' +
        '</p>\n' +
        '<p style="text-indent:28px">\n' +
        '    <span style="font-family: 微软雅黑; font-size: 14px; color: rgb(63, 63, 63);">视觉导航是所有导航中公认的终极解决方案。著名电动车公司特斯拉的自动驾驶方案也是采用的视觉导航。2019年4月22日，特斯拉CEO埃隆马斯克在加州举办的Autonomy Day上甚至夸张地发言：“激光雷达是傻子才在采用，仰赖激光雷达注定要失败”。但由于视觉导航技术门槛非常高，虽然知道视觉导航是技术趋势，但将视觉导航技术投入商业应用，对于很多机器人厂家来讲，是可望而不可及。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <br/>\n' +
        '</p>'
    },
    {
      'id':'1',
      'name':'除湿器的三种排水方法',
      'article':'<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">变电站户内巡检、户外巡检，由于面向巡检对象不同，选用的机器人也有差异。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">变电站户内巡检一般是针对开关室，巡检内容一般包括三类：</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">1、<span style="color: rgb(38, 38, 38); font-family: 宋体;">状态巡检：表计、指示灯、标示牌</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">2、<span style="color: rgb(38, 38, 38); font-family: 宋体;">设备巡检：局放、测温、声音</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">3、<span style="color: rgb(38, 38, 38); font-family: 宋体;">环境巡检：</span>SF6<span style="color: rgb(38, 38, 38); font-family: 宋体;">气体监测、温湿度、消防</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">所以户内巡检机器人一般除了摄像头进行图像识别，还需要携带传感器。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">变电站户外巡检针对户外设备，巡检内容一般也包括三类：</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">1、<span style="color: rgb(38, 38, 38); font-family: 宋体;">状态巡检：表计、指示灯、标示牌</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">2、<span style="color: rgb(38, 38, 38); font-family: 宋体;">设备巡检：测温、声音</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="color: rgb(38, 38, 38); font-family: 宋体; font-size: 14px;">3、<span style="color: rgb(38, 38, 38); font-family: 宋体;">环境巡检：温湿度、风速、风向</span></span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">相较户内巡检，机器人携带的传感器种类就非常少。这主要是因为部分户内监测项目，由于户外设备特性，机器人无法在户外进行巡检。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">目前户内、户外巡检的机器人结构不同，户内大多采用轨道巡检机器人，户外采用轮式巡检机器人。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">轨道机器人有轨定位，相对比较容易、准确；轮式机器人无轨运行，定位难度非常大，这是轮式机器人在户内巡检相对数量少很多的主要原因。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">但轮式机器人较轨道机器人，在项目实施上有一个很大的好处，就是几乎轮式机器人几乎免安装，而轨道机器人安装比较复杂，有时为安全考虑，甚至停电安装。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <span style="font-family: 宋体; font-size: 14px; color: rgb(38, 38, 38);">所以，在确保准确定位和导航的情况下，盈能电气已经将轮式机器人应用于开关室巡检，在可靠的导航和定位技术下，YNEN-9XL2巡检机器人可以无轨覆盖开关室全部区域，携带的多种传感器，提供全面的巡检监测。由于其免安装，极大地提高了巡检机器人的部署速度。</span>\n' +
        '</p>\n' +
        '<p>\n' +
        '    <br/>\n' +
        '</p>'
    },
  ]
};



// WEBPACK FOOTER //
// ./src/assets/data/server.js